<template>
  <b-card>
    <b-button
      variant="success"
      class="m-1"
      @click="showAddOrEditMetaModal(false)"
      >اضافه کردن متا جدید</b-button
    >
    <b-button
      variant="danger"
      class="m-1"
      @click="$router.push({ name: 'metadataGroups' })"
      >بازگشت</b-button
    >
    <b-table
      responsive
      style="width: 100%"
      striped
      hover
      show-empty
      empty-text="آیتمی جهت نمایش وجود ندارد"
      :fields="fields"
      :items="metadataList"
    >
      <template v-slot:cell(edit)="row">
        <b-link variant="success" @click="editMetaData(row.item)" href="#"
          >ویرایش</b-link
        >
      </template>
    </b-table>
    <b-modal
      ref="addmeta-modal"
      :title="metaModalTitle"
      style="justify-content: space-around"
      hide-footer
    >
      <b-form>
        <b-row>
          <b-col>
            <label style="margin-left: auto">عنوان</label>
            <b-input
              id="input_meta_name"
              placeholder="عنوان متا دیتا"
              v-model="newMetaData.title"
            />
          </b-col>
          <b-col style="align-self: flex-end">
            <label style="margin-left: auto">گروه والد</label>
            <b-form-select
              :options="metadataGroupNameList"
              v-model="newMetaData.metadata_group_id"
              style="align-items: center"
              @change="loadMetadataParentList"
            ></b-form-select>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col style="align-self: flex-end">
            <label style="margin-left: auto">والد</label>
            <b-form-select
              v-model="newMetaData.parent_id"
              :options="metadataParentList"
              style="align-items: center"
            ></b-form-select>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-input
              id="input_meta_name"
              placeholder="کد لاتین"
              v-model="newMetaData.latin_code"
            />
          </b-col>
          <b-col>
            <b-input
              id="input_meta_name"
              placeholder="کد"
              v-model="newMetaData.code"
            />
          </b-col>
          <b-col cols="12">
            <b-form-group
              id="input-group-4"
              label="توضیحات"
              label-for="input-4"
              class="mt-3"
            >
              <b-form-textarea
                id="input-4"
                v-model="newMetaData.description"
                placeholder="توضیحات را اینجا تایپ کنید"
                rows="8"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col align-self="end">
            <b-button
              style="width: 100%"
              variant="primary"
              @click="sendAddOrEditMetaRequest"
              >ذخیره</b-button
            >
          </b-col>
          <b-col>
            <b-button
              style="width: 100%"
              variant="danger"
              @click="hideAddOrEditMetaModal"
              >بازگشت</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </b-card>
</template>
<script>
import httpHelper from "../../helpers/httpHelper";
import persianDate from "../../helpers/persianDate";
import MDDropdown from "../../components/MDDropdown";

export default {
  name: "MetadataList",
  components: { MDDropdown },
  data: function () {
    return {
      newMetaData: {
        title: null,
        parent_id: null,
        metadata_group_id: null,
        latin_code: null,
        code: null,
        description: null,
      },
      metadataList: [],
      metadataGroupList: [],
      metadataGroupNameList: [],
      metadataParentList: [],
      metaModalTitle: "اضافه کردن متا دیتا",
      metaParentGroupId: null,
      isInEditMode: false,
      fields: [
        {
          key: "id",
          label: "ردیف",
        },
        {
          key: "title",
          label: "عنوان",
        },
        {
          key: "created_at",
          label: "تاریخ ایجاد",
        },
        {
          key: "updated_at",
          label: "تاریخ بروزرسانی",
        },
        {
          key: "edit",
          label: "",
        },
      ],
    };
  },
  methods: {
    getMetadataGroups: function () {
      httpHelper.setAuth();
      httpHelper.getData("metadata/groups").then((response) => {
        this.metadataGroupList = response.result;
        this.metadataGroupNameList = this.metadataGroupList.map((item) => {
          return {
            value: item.id,
            text: item.name,
          };
        });
      });
    },
    sendAddOrEditMetaRequest: function () {
      if (this.isInEditMode) this.newMetaData.id = this.metaDataId;
      this.newMetaData.metadata_group_id = this.$route.params.id;
      httpHelper.postData("metadata", this.newMetaData).then((response) => {
        if (response.success === true) {
          this.$makeToast(
            "success",
            "ذخیره موفق",
            "متا دیتای جدید اضافه شد.",
            5000
          );
          this.getMetadataList();
          this.hideAddOrEditMetaModal();
        }
      });
    },
    loadMetadataParentList: function () {
      httpHelper
        .getData(
          "metadata?metadata_group_id=" + this.newMetaData.metadata_group_id
        )
        .then((response) => {
          this.metadataParentList = response.result.map((item) => {
            return {
              value: item.id,
              text: item.title,
            };
          });
        })
        .finally(() => []);
    },
    showAddOrEditMetaModal: function (isInEditMode) {
      if (!isInEditMode) {
        this.isInEditMode = isInEditMode;
        this.newMetaData = {};
        this.$refs["addmeta-modal"].show();
        this.metaModalTitle = "اضافه کردن متا دیتا";
      } else {
        this.$refs["addmeta-modal"].show();
        this.metaModalTitle = "ویرایش متا دیتا";
      }
    },
    hideAddOrEditMetaModal: function () {
      this.$refs["addmeta-modal"].hide();
    },
    getMetadataList: function () {
      httpHelper.setAuth();
      httpHelper
        .getData("metadata?metadata_group_id=" + this.$route.params.id)
        .then((response) => {
          this.metadataList = response.result;
          this.metadataList.map((item) => {
            if (item["created_at"] !== null)
              item["created_at"] = persianDate.getDate(item["created_at"]);
            if (item["updated_at"] !== null)
              item["updated_at"] = persianDate.getDate(item["updated_at"]);
          });
        })
        .finally(() => {});
    },
    editMetaData: function (meta) {
      (this.newMetaData = {
        title: null,
        parent_id: null,
        metadata_group_id: null,
        latin_code: null,
        code: null,
        description: null,
      }),
        httpHelper.setAuth();
      httpHelper.getData("metadata?id=" + meta.id).then((response) => {
        if ((response.success = true)) {
          let metaData = response.result[0];
          this.metaDataId = metaData.id;
          this.newMetaData.title = metaData.title;
          this.newMetaData.metadata_group_id = metaData.metadata_group_id;
          if (metaData.parent) {
            this.newMetaData.parent_id = metaData.parent.id;
            this.loadMetadataParentList();
          }
          this.newMetaData.latin_code = metaData.latin_code;
          this.newMetaData.code = metaData.code;
          this.isInEditMode = true;
          this.metaModalTitle = "ویرایش متا دیتا";
          this.newMetaData.description = metaData.description;
          this.showAddOrEditMetaModal(true);
        }
      });
    },
  },
  created() {
    this.getMetadataList();
    this.getMetadataGroups();
  },
};
</script>